import { Controller } from "@hotwired/stimulus"
export default class extends Controller {

  static targets = [
    "pricingButton",
    "pricingList",
    "additional"
  ]

  connect() {
    const pathname = window.location.pathname;
    const hash = window.location.hash.split("#").pop().toLowerCase();

    // trigger pricing if hash matches a currency and we're on the pricing page
    if( ['gbp','usd','eur'].includes(hash) && pathname.includes('pricing') ) {
      this.triggerPricing(hash);
    }
  }

  triggerPricing(currency) {
    var event = document.createEvent('HTMLEvents');
    event.initEvent('click', true, false);
    document.querySelector('button[data-currency="' + currency  + '"]').dispatchEvent(event);
  }

  switchPricing(event) {

    // unset current active tab
    var element = event.target;
    element.parentNode.parentNode.querySelector('.active').classList.remove('active');

    // set new active tab
    event.currentTarget.classList.add('active');

    // get currency to switch to
    var currency = event.currentTarget.getAttribute('data-currency');

    // update URL
    window.history.pushState({}, '', '/pricing#' + currency);

    // get additional pricing
    const additionalPricing = new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currencyDisplay: 'narrowSymbol',
      currency: currency
    }).formatToParts(2.50).map(val => val.value).join('');

    this.additionalTargets.forEach(function(item, i){
        item.innerHTML = additionalPricing;
    });

    // switch all prices
    this.pricingListTarget.querySelectorAll('div[data-currency]').forEach(function(item, i){

      if( item.getAttribute('data-currency') === currency ) {
        item.classList.remove('hidden');
      } else {
        item.classList.add('hidden');
      }

    });

  }

}